export const PURCHASE_REQUEST_STATUS = [
    { value: 'draft', name: 'Draft', label: 'Draft' },
    { value: 'submitted', name: 'Submitted', label: 'Submitted' },
    { value: 'offer_submitted', name: 'Offer Submitted', label: 'Offer Submitted' },
    { value: 'broker_offer_submitted', name: 'Broker Offer Submitted', label: 'Broker Offer Submitted' },
    { value: 'processing', name: 'Processing', label: 'Processing' },
    { value: 'offer_rejected', name: 'Offer Rejected', label: 'Offer Rejected' },
    { value: 'offer_accepted', name: 'Offer Accepted', label: 'Offer Accepted' },
    { value: 'completed', name: 'Completed', label: 'Completed' },
]